export const ATTENDANCE_REFRESH_KEY = "attendance_list_refresh";

export function notifyAttendanceUpdated() {
  localStorage.setItem(ATTENDANCE_REFRESH_KEY, String(Date.now()));
}
